import { useEffect, useState } from "react";
import * as logo from "../state/logo";

/**
 * Merket i menyen — eller produksjonens logo, når den finnes.
 *
 * ========  HVORFOR ET BILDE OG IKKE EN MASKE  ========
 *
 * Infoflyt-merket tegnes som en maske med `--mark-color`, slik at det tar
 * farge av paletten og virker i blackout. En kundes logo kan ikke det: den
 * har sine egne farger, og å legge dem i en maske ville gjort den til en
 * ensfarget flekk. Derfor to ulike elementer, og ikke ett med bytte av
 * kilde.
 *
 * ========  LENKA ER SIGNERT, OG KORT  ========
 *
 * Bøtta er privat — en logo sier hvem som er i gang med hva. Lenka varer
 * en time, og hentes på nytt når økten bygges. Nettflata er online-først,
 * så det holder; feltappen må lagre selve fila, og gjør det et annet sted.
 */
/* `string | null | undefined` og ikke et valgfritt felt: med
   `exactOptionalPropertyTypes` er «kan utelates» og «kan vaere
   undefined» to ulike ting, og stien er det siste. */
export function Merke(
  { sti }: { readonly sti: string | null | undefined },
): JSX.Element {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let levende = true;
    setUrl(null);
    if (sti === null || sti === undefined || sti === "") return;
    void (async () => {
      const u = await logo.lenke(sti);
      if (levende) setUrl(u);
    })();
    return () => { levende = false; };
  }, [sti]);

  /* Mens lenka hentes staar merket. Et hull som fylles et halvt sekund
     senere er verre enn et merke som byttes. */
  if (url === null) return <span className="merke" aria-hidden="true" />;
  return <img className="merke merke--logo" src={url} alt="" />;
}
